import { render, staticRenderFns } from "./PrimaryCareProvider.vue?vue&type=template&id=f79377fe"
import script from "./PrimaryCareProvider.vue?vue&type=script&lang=js"
export * from "./PrimaryCareProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports